import * as React from "react";

const IconFooterMessage: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="14" height="11" viewBox="0 0 14 11" fill="currentColor"><path fill="currentColor" d="M0.875,2.60312533 L7,6.81406283 L13.125,2.60312533 L13.125,0.875 L0.875,0.875 L0.875,2.60312533 Z M13.125,3.6640625 L7,7.875 L0.875,3.6640625 L0.875,9.625 L13.125,9.625 L13.125,3.6640625 Z M0,9.625 L0,3.0625 L0,0.875 L0,0 L0.875,0 L13.125,0 L14,0 L14,0.875 L14,3.0625 L14,9.625 L14,10.5 L13.125,10.5 L0.875,10.5 L0,10.5 L0,9.625 Z" transform="translate(0 .5)"/></svg>;
};

export default React.memo(IconFooterMessage);
